<div class="common-wrapper">
    <div class="main-hd-txt">
        <h4>  <!-- <i class="{{activeMenuIcon}}"></i> --> {{activeMenuName}}</h4> 
        <!-- <p>{{activeModuleName}}</p> -->
    </div>
    <div class="col-md-12 ps-3" *ngIf="showINMDashboard">
        <div class="row" *ngIf="showINMDashboard">
            <div class="col-md-6">
                In Progress INM
            </div>
        </div>
    </div>
    <div class="row m-0" *ngIf="!showINMDashboard && !showMMDashboard && !showCRDashboard">
        <div class="col-lg-4 p-1" *ngFor="let menu of menuList;" (click)="navigateUrl(menu)">
            <div class="card-wrap"> 
                <h6 [ngClass]="{'comp-ic' : true}"><i  class="{{ menu.Menu_Icon }}"></i> {{ menu.Menu_Name }}
                    <!-- <p>{{ menu.Menu_Description }}</p> -->
                </h6>
                
            </div>
        </div>
    </div>

    <div class="col-md-12 pe-4" *ngIf="showMMDashboard">
        <div class="row" *ngIf="showMMDashboard">
            <div class="col-md-6">
                In Progress MM
            </div>
        </div>
    </div>


    <div class="col-md-12 pe-4" *ngIf="showCRDashboard">
        <div class="row" *ngIf="showCRDashboard">
            <div class="col-md-6">
                In Progress CR
            </div>
        </div>
    </div>

</div>